import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import globalAppStore from '@/modules/app/app.store';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  modules: {
    app: globalAppStore
    //  firstForm: fistFormStore,
  },
  plugins: [vuexLocal.plugin]
});
